/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
import { ok } from "../../data/file-system/utils.js";
export { ExportsDescriber };
class ExportsDescriber {
    mutable;
    describerFactory;
    constructor(mutable, describerFactory) {
        this.mutable = mutable;
        this.describerFactory = describerFactory;
    }
    async transform(result) {
        const { exports } = this.mutable.graph;
        if (!exports)
            return result;
        const entries = Object.fromEntries((await Promise.all(exports.map(async (id) => {
            const describer = this.describerFactory(id, this.mutable);
            if (!ok(describer))
                return null;
            const result = await describer.describe();
            const url = `${this.mutable.graph.url}${id}`;
            return [url, result];
        }))).filter((item) => item !== null));
        return { ...result, exports: entries };
    }
}
//# sourceMappingURL=exports-describer.js.map